<template>
  <div class="flex items-center justify-center min-h-[400px]">
    <div class="text-center max-w-sm">
      <!-- Icon -->
      <div class="mx-auto w-16 h-16 bg-gradient-to-br from-indigo-100 to-purple-100 rounded-2xl flex items-center justify-center mb-6">
        <svg class="w-8 h-8 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"></path>
        </svg>
      </div>

      <!-- Badge -->
      <span class="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-amber-50 text-amber-700 text-xs font-medium mb-4">
        <span class="w-1.5 h-1.5 bg-amber-500 rounded-full animate-pulse"></span>
        {{ t('coming_soon') }}
      </span>

      <!-- Title -->
      <h2 class="text-xl font-semibold text-gray-900 mb-2">{{ t('checkout_page_button') }}</h2>

      <!-- Description -->
      <p class="text-sm text-gray-500 leading-relaxed">
        {{ t('wc_checkout_coming_soon_desc') }}
      </p>
    </div>
  </div>
</template>

<script setup>
import { useTranslation } from '../../composables/useTranslation';

const { t } = useTranslation();
</script>
